//candMsgsController.js
'use strict';

var notfIntervalRef = null;
app = angular.module('harriApp');
app.controller('candMsgsController', ["$scope", "hUser", "$stateParams", "$state", "$location", "$timeout", "chatAPI", "$rootScope", "$interval", "userPermissions", function ($scope, hUser, $stateParams, $state, $location, $timeout, chatAPI, $rootScope, $interval, userPermissions) {


    $scope.mobileView = false;
    $scope.brandMobileView = false;
    $scope.hasMsgsFromEmployer = false;
    $scope.dataLoaded = false;
    $scope.apps = [];
    $scope.offset = 0;
    $scope.limit = 30;
    $scope.appsRevIndex = {};
    $scope.latestMsgDate = null;
    $scope.firstLoad = true;
    //$scope.selected_brand_id = false;


    $scope.$on('$destroy',function(){
      $interval.cancel($scope.brandUpdateInterval);
      $interval.cancel($scope.appsInterval);

      $scope = {};
    });


    /**
     * Update Applications
     *
     * @param returned_apps
     */
    $scope.updateApps = function (returned_apps, includeArchived) {
        //$scope.selected_app_id = false;
        if ( _.isArray( returned_apps ) && returned_apps.length > 0 ) {
            _.each(returned_apps, function (app, index) {
                if (!$scope.appsRevIndex[app.id]) {
                    $scope.apps.push($scope.prepare_app(app));
                    $scope.appsRevIndex[ $scope.apps[$scope.apps.length-1].id ] = $scope.apps.length-1;
                }
            });

            $scope.latestMsgDate = $scope.apps[0].last_message_date;


            if (( !$scope.firstLoad && $scope.initialParams.id ) || $.trim( $scope.initialParams.id ) == '') {
                // not to update the app id in the link
                $timeout(function () {
                    $scope.initialParams = {};

                    if( !$scope.selected_app_id ){
                        $scope.selected_app_id = $scope.apps[0].id;
                    }
                });
            }
            else {
                $scope.firstload = false;

                $timeout(function () {
                  if( $scope.initialParams.id ){
                    $scope.selected_app_id = $scope.initialParams.id;
                  }else{
                    $scope.selected_app_id = false;
                  }

                  $scope.initialParams = {};
                });
            }


            $rootScope.$broadcast('releaseChatScrollLock');

            if ($scope.offset == 0) {

                $scope.appsInterval = $interval(function () {

                    if (hUser.isLoggedIn()) {
                        chatAPI.getAppsUpdate($scope.latestMsgDate, $scope.isEmployer, $scope.selected_brand_id, includeArchived);

                        if( $scope.isEmployer ){
                            chatAPI.getBrandsUpdates(hUser.getUserContext().brand_id, includeArchived).then(function(resp){

                                $interval.cancel($scope.brandUpdateInterval);

                                if( $scope.updateBrandsMessagesCount ){
                                    $scope.updateBrandsMessagesCount(resp.data.data);
                                }

                            });
                        }
                    }

                }, publicConfiguration.refreshRate);
                $scope.selected_app_id = $scope.initialParams.id && $scope.selected_app_id != '' ? $scope.initialParams.id : false;
            }

            $scope.offset += 30;



        }else {
            if( $scope.offset == 0 ){
                $scope.apps = [];
            }
            $scope.initialParams = {};
        }

        if( !_.isArray( returned_apps ) || returned_apps.length == 0 ){

          if( $scope.isEmployer ){
            $interval.cancel($scope.brandUpdateInterval);
            $scope.brandUpdateInterval = $interval(function(){
                if (hUser.isLoggedIn()) {
                    chatAPI.getBrandsUpdates(hUser.getUserContext().brand_id, includeArchived).then(function(resp){
                        if( $scope.updateBrandsMessagesCount ){
                            $scope.updateBrandsMessagesCount(resp.data.data);
                        }
                        $scope.$broadcast('updateHeaderNotf');
                    });
                }
            }, publicConfiguration.refreshRate);
          }

        }


        $scope.dataLoaded = true;
        PerformanceUtils.trackLoaded(hUser, $state);
    };

    /**
     * update employer brands unread messages count
     */
    $scope.updateBrandsMessagesCount = function(brandsArray){

      var updateHeader = false

      _.each( brandsArray , function( brand ){

          var brandLocation = _.findWhere( $scope.brandsHashTable , {brand : brand.brand_id } );

          var BrandLocationIndexes = {}

          if( brandLocation ){

              if( brandLocation.parent_brand ){

                  BrandLocationIndexes.parent_index = _.indexOf($scope.employerBrands, _.findWhere( $scope.employerBrands , { id: brandLocation.parent_brand } ) );
                  BrandLocationIndexes.brand_index = _.indexOf($scope.employerBrands, _.findWhere( $scope.employerBrands[BrandLocationIndexes.parent_index].children , { id: brandLocation.brand } ) );

                  if( BrandLocationIndexes.parent_index != -1 &&  BrandLocationIndexes.brand_index != -1 && brand.count ){
                      $scope.employerBrands[BrandLocationIndexes.parent_index].children[BrandLocationIndexes.brand_index].unread_counter = brand.count;
                      updateHeader = true;
                  }
              }else{
                  BrandLocationIndexes.brand_index = _.indexOf($scope.employerBrands, _.findWhere( $scope.employerBrands , { id: brandLocation.brand } ) );

                  if( BrandLocationIndexes.brand_index != -1 && brand.count ){
                      $scope.employerBrands[BrandLocationIndexes.brand_index].unread_counter = brand.count;
                      updateHeader = true;
                  }
              }
          }


      });

      if(updateHeader){
        $timeout(function(){
          $scope.$broadcast('updateHeaderNotf');
        });
      }

    }



    /**
     * Format Brands Data
     * @param brandsList
     */
    $scope.formatBrands = function( brandsList ){


      $scope.brandsHashTable = [];
      var brands = [];
      brands = _.map(brandsList,function( brand ){

        if( brand.Brand.length ){

          var children = [];

          var currentBrand = brand.Brand[0].Brand.id;

          if( brand.Children.length ){
            children = _.map(brand.Children, function(brand){

              if( brand.info.length ){
                var childProfileImage = _.findWhere(brand.info[0].Brand.BrandMedia,{"type" : "profile_image"});
                $scope.brandsHashTable.push( { brand : brand.info[0].Brand.id , parent_brand : currentBrand } )
                return {
                  name : brand.info[0].Brand.name,
                  id : brand.info[0].Brand.id,
                  slug : brand.info[0].Brand.slug,
                  media:  childProfileImage || null,
                  Location : brand.info[0].Brand.Location,
                  unread_counter : brand.info[0].Brand.unread_messages_count || 0
                }
              }

            });
          }
          var brandProfileImage = _.findWhere(brand.Brand[0].Brand.BrandMedia,{"type" : "profile_image"});
          $scope.brandsHashTable.push( { brand : currentBrand , parent_brand : null } );
          return {
            name : brand.Brand[0].Brand.name,
            id : brand.Brand[0].Brand.id,
            slug : brand.Brand[0].Brand.slug,
            media:  brandProfileImage || null,
            Location : brand.Brand[0].Brand.Location,
            unread_counter : brand.Brand[0].Brand.unread_messages_count || 0,
            children : children
          }
        }

      });
      return brands;
    }

    $scope.onArchivedLocationsChange = function () {
        $scope.selected_brand_id = null;
        $scope.loadingMessages = true;
        $scope.apps.length = 0;
        delete $scope.employerBrands;
        getEmpBrands($scope.showArchivedLocations);
    };

    /**
     * Get Selected Brand Messages
     */
    $scope.loadEmpAppsList = function(offset,limit,brandId, includeArchived){
      $scope.loadingMessages = true;
      chatAPI.getEmpApp(offset, limit, brandId, includeArchived).then(function (resp) {

        // fixing race condition when the user navigate between brands
        if (brandId !== $scope.selected_brand_id) {
          return;
        }

        $scope.updateApps(resp.data.data, includeArchived);

        $timeout(function(){
          $scope.loadingMessages = false;
        });

      });
    }
    var getEmpBrands = function (includeArchived) {
        $scope.loadingBrands = true;
        chatAPI.getEmpBrands(hUser.getUserContext().brand_id, includeArchived).then(function (resp) {

            $scope.employerBrands = $scope.formatBrands(resp.data.data);
            if ($scope.initialParams.brand) {
                $scope.selected_brand_id = $scope.initialParams.brand;
                $scope.initialParams.brand = null;
            } else if ($scope.employerBrands.length) {
                $scope.selected_brand_id = $scope.employerBrands[0].id;
                $scope.initialParams.brand = null;
            }
        }).catch(function (err) {
            console.error(err);
        }).finally(function () {
            delete $scope.loadingBrands;
        });
    }



    /**
     * Initial Request
     *
     * @param offset
     * @param limit
     */
    $scope.initRequest = function (offset, limit) {
        PerformanceUtils.trackWhenUIReady(".msgs-wrapper", hUser, $state);
        if ($scope.isEmployer) {

            // Get the employers brands
            if( $scope.employerBrands == undefined || $scope.employerBrands.length == 0){

               getEmpBrands();
            }else{

                chatAPI.getEmpApp($scope.offset, $scope.limit, $scope.selected_brand_id ).then(function (resp) {
                    $scope.updateApps( resp.data.data );
                });
            }

        }
        else {
            chatAPI.getCandApp(offset, limit).then(function (resp) {
                $scope.updateApps(resp.data.data);
            });
        }
    };


    var chatNewAppsUpdatesLocked = false;
    $scope.$on('chatNewAppsUpdates', function (e, newApps) {
        var newApp;
        if (newApps.length > 0 && !chatNewAppsUpdatesLocked) {
            chatNewAppsUpdatesLocked = true;
            // remove apps
            _.each(newApps, function (newApp, index) {
                newApp = $scope.prepare_app(newApp);
                if ($scope.appsRevIndex.hasOwnProperty(newApp.id)) {
                    ar_delete($scope.apps, $scope.appsRevIndex[newApp.id]);
                }
            });

            // unshift new apps
            _.each(newApps, function (newApp, index) {
                newApp = $scope.prepare_app(newApp);
                $scope.apps.unshift(newApp);
                $scope.$broadcast('setReadAsZeroIfSelected', newApp.id);
            });

            // add new apps
            $scope.appsRevIndex = {};
            _.each($scope.apps, function (app, index) {
                $scope.appsRevIndex[ app.id ] = index;
            });

            $scope.latestMsgDate = newApps[0].last_message_date;

            $timeout(function () {
                $scope.$apply();
                chatNewAppsUpdatesLocked = false;
            })
        }
    });


    /**
     * Prepare app data for both candidate & employer
     *
     * @param obj
     * @returns {*}
     */
    $scope.prepare_app = function (obj) {
        if ($scope.isEmployer) {
            return {
                'id': obj.application_id,
                'name': obj.applicant_name,
                'last_name': obj.applicant_last_name,
                'photo': obj.applicant_photo,
                'applicant_id': obj.applicant_id,
                'slug' : obj.applicant_slug,
                'last_message_date': obj.last_message_date,
                'position': obj.position,
                'bucket_id': obj.bucket,
                'bucket_name': obj.bucket_name,
                'job_id': obj.job_id,
                'media_type': 'user_photo',
                'unread_counter': obj.unread_counter || 0,
                'is_walkin': obj.application_status === "Draft"
            }
        }
        else {
          return {
                'id': obj.application_id,
                'name': obj.brand_name,
                'photo': obj.brand_photo,
                'photo_extension': obj.brand_photo_file_extension,
                'photo_path': obj.brand_photo_path,
                'slug' : obj.brand_slug,
                'brand_id': obj.brand_id,
                'last_message_date': obj.last_message_date,
                'position': obj.position,
                'media_type': 'brand_file',
                'unread_counter': obj.unread_counter || 0
            }
        }

    };


  /**
   * Return the Url of the Selected message
   * @param appId
   * @param brandId?
   */
    $scope.prepareMessageUrl = function(appId , brandId){
      brandId = brandId || false;
      appId = appId || false;

      var paramsUrl = "";

      if( brandId ){
        paramsUrl += "/brand/"+brandId;
      }

      if( appId ){
        paramsUrl += '/app/'+appId;
      }

      return paramsUrl;
    }

    /**
     * Change The URL
     * @param appId
     * @param brandId
     */
    var changeMessageViewUrl = function () {

        if (!!$scope.initialParams.id == false && !!$scope.initialParams.brand == false) {
            var appId = $scope.selected_app_id;
            var brandId = $scope.selected_brand_id;
            var params = $scope.prepareMessageUrl(appId, brandId);

            $state.go('appLayout.harriSH.messages', {params: params});
        }

    };


    // watch the change selected application id and change the URL according to that
    $scope.$watch('selected_app_id', function (newVal, oldVal) {

        if (oldVal && (newVal || newVal == false)) {
            changeMessageViewUrl();
        }

        if( !$scope.appsRevIndex.hasOwnProperty(newVal) && $scope.apps[0] && $scope.apps[0].id ){
            $scope.selected_app_id = $scope.apps[0].id;
            return;
        }



        if (newVal && $scope.apps && $scope.apps.length > 0) {

            var card = $scope.apps[$scope.appsRevIndex[newVal]];
            if ($scope.isEmployer) {

                $scope.candImageId = '';
                $scope.candId = '';

                if ($scope.appsRevIndex.hasOwnProperty(newVal) &&
                    $scope.apps[$scope.appsRevIndex[newVal]] &&
                    $scope.apps[$scope.appsRevIndex[newVal]].photo) {
                    $scope.candImageId = $scope.apps[$scope.appsRevIndex[newVal]].photo;
                    $scope.candId = $scope.apps[$scope.appsRevIndex[newVal]].applicant_id;
                }
            }


            if (card) {
                card.unread_counter = 0;
            }


            $timeout(function(){
                $scope.$apply();
            });

            // close menu on mobile
            if( !$scope.isEmployer ){
              $scope.mobileView = true;
            }else{
              $scope.mobileView = false;
            }


        }
    });


    $scope.$watch('selected_brand_id', function (newVal, oldVal) {
        if (newVal || newVal == false) {
            $interval.cancel(notfIntervalRef);
            $interval.cancel($scope.appsInterval);
            $scope.selected_app_id = false;
            $scope.apps = [];
            $scope.appsRevIndex = {};
            $scope.offset = 0;

            $scope.loadEmpAppsList($scope.offset, $scope.limit, newVal, $scope.showArchivedLocations);

            if (oldVal && newVal != oldVal) {
                changeMessageViewUrl();
            }
        }
    });

    // is employer or candidate
    $scope.$watch(function () {
        return hUser && hUser.data && hUser.data.user && hUser.data.user.user_employer;
    }, function (newVal, oldVal) {

        if (newVal) {
            $scope.isEmployer = newVal;
            $scope.senderType = 'Employer';
        }
        else {
            $scope.senderType = 'Applicant';
            $scope.isEmployer = false;
        }


        /**
         * Parse URL
         */

        $scope.initialParams = {};

        if( $stateParams.params ){
          var urlParams = $stateParams.params.split('/');

          if( urlParams.indexOf('brand') != -1 ){
            $scope.initialParams.brand =  urlParams[ urlParams.indexOf('brand') + 1 ];
          }

          if( urlParams.indexOf('app') != -1 ){
            $scope.initialParams.id =  urlParams[ urlParams.indexOf('app') + 1 ];
          }

        }
        if ($scope.isEmployer) {
            userPermissions.getBrandPolicy(hUser.getUserContext().brand_id)
                .then(function (policyParser) {
                    $scope.hasManageArchivedLocation = policyParser.brands(policyParser.ANY).has(userPermissions.PERMISSIONS.ACCESS_CLOSED_LOCATIONS);
                }).catch(function (error) {
                $scope.hasManageArchivedLocation = false;
                console.error(error);
            });
        }


        $scope.initRequest($scope.offset, $scope.limit);

    });

    $scope.$on('chatReachedBottom', function (e) {
        $scope.initRequest($scope.offset, $scope.limit);
    });

    $scope.$on('newSelectedAppId', function(e, newAppId){
        $scope.selected_app_id = newAppId;
        $timeout(function(){
            $scope.$apply();
        })
    });

    $scope.$on('newSelectedBrandId',function(e, newBrandId){
      $scope.selected_brand_id = newBrandId;
      $timeout(function(){
        $scope.$apply();
      })
    });

    // this event set read counter as zero
    $scope.$on('setReadAsZeroIfSelected', function(e, appId){
        if( appId == $scope.selected_app_id ){
            $scope.apps[$scope.appsRevIndex[appId]].unread_counter = 0;
            $timeout(function(){
                $scope.$apply();
            });
        }
    });

}]).controller('notfController', ["$scope", "chatAPI", "$interval", "hUser", function ($scope, chatAPI, $interval, hUser) {

    $scope.unread_count = chatAPI.unreadCount || 0;

    // is employer or candidate
    $scope.$watch(function () {
        return hUser && hUser.data && hUser.data.user && hUser.data.user.user_employer;
    }, function (newVal, oldVal) {

        if (newVal) {
            $scope.isEmployer = newVal;
            $scope.senderType = 'Employer';
        }
        else {
            $scope.isEmployer = false;
        }


        $scope.getUpdates();
        $interval.cancel(notfIntervalRef);
        notfIntervalRef = $interval(function () {
            if (hUser.isLoggedIn()) {
                $scope.getUpdates();
            }
        }, publicConfiguration.refreshRate);

    });

    // sync read msgs on header and on msgs
    $scope.$on('updateHeaderNotf', function (e, forceUpdate) {
        $scope.getUpdates(forceUpdate);
    });

    $scope.getUpdates = function (forceUpdate) {
        if (document.hasFocus()) {
            if (forceUpdate || (Date.now() - chatAPI.lastCheck) >= publicConfiguration.refreshRate) {
                if ($scope.isEmployer && hUser.getUserContext() && hUser.getUserContext().brand_id) {
                    chatAPI.getUpdates($scope.isEmployer).then(function (resp) {
                        if (resp && resp.data && resp.data.data) {
                            $scope.unread_count = resp.data.data;
                            chatAPI.unreadCount = $scope.unread_count;
                        }
                        else {
                            $scope.unread_count = 0;
                        }
                    });
                } else {
                    chatAPI.getUpdates(false).then(function (resp) {
                        if (resp && resp.data && resp.data.data) {
                            $scope.unread_count = resp.data.data;
                            chatAPI.unreadCount = $scope.unread_count;
                        }
                        else {
                            $scope.unread_count = 0;
                        }
                    });
                }
            }
        }
    };

}]);
